import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    claimsMappingSelectedTagsFilter: [],
    tags: [],
};

export const claimsMappingStore = createSlice({
    name: "claimsMappingStore",
    initialState,
    reducers: {
        loadClaimsMappingSelectedTagsFilterState: (state, action) => {
            state.claimsMappingSelectedTagsFilter = action.payload;
        },
        loadTagsState: (state, action) => {
            state.tags = action.payload;
        },
        resetClaimsMappingStore: () => initialState,
    },
});
export const { loadClaimsMappingSelectedTagsFilterState, resetClaimsMappingStore, loadTagsState } = claimsMappingStore.actions;

export default claimsMappingStore.reducer;
